import { createContext } from 'react'

import { EndAbTestContextType } from './types'

export const EndAbTestContext = createContext<EndAbTestContextType>({} as EndAbTestContextType)
